export default {"src":"/_next/static/image/public/images/flags/flag_677.96e79afc483dfa23615829fcc0bc031b.svg","height":16,"width":24};